import isDesktop from '@lib/is-desktop';
import once from '@lib/once';
import _throttle from 'lodash/throttle';

function initFoldableCard(element) {
    const image = element.querySelector('.product-teaser-card__image');
    const headline = element.querySelector('.product-teaser-card__headline');

    let hovering = false;
    let focused = false;
    let initialHeight;

    calculateInitialHeight();
    updateHeight();

    element.addEventListener('mouseenter', function () {
        hovering = true;
        updateHeight();
    });
    element.addEventListener('mouseleave', function () {
        hovering = false;
        updateHeight();
    });
    element.addEventListener('focusin', function () {
        focused = true;
        element.scrollTop = 0;
        updateHeight();
    });
    element.addEventListener('focusout', function () {
        focused = false;
        updateHeight();
    });

    let prevIsDesktop = false;
    // recalculate initial height when resizing back to desktop
    window.addEventListener(
        'resize',
        () => {
            const isDesktopNow = isDesktop();
            if (isDesktopNow !== prevIsDesktop) calculateInitialHeight();
            prevIsDesktop = isDesktopNow;
        },
        { passive: true }
    );

    window.addEventListener('resize', _throttle(updateHeight, 100), { passive: true });

    function calculateInitialHeight() {
        element.style.removeProperty('height');
        initialHeight = element.scrollHeight;
        return initialHeight;
    }

    function updateHeight() {
        if (!hovering && !focused && isDesktop()) {
            element.style.height = image.offsetHeight + headline.offsetHeight + 'px';
        } else {
            element.style.height = initialHeight + 'px';
        }
    }
}

window.Drupal.behaviors.productTeaserCard = {
    attach: function (context) {
        context.querySelectorAll('.product-teaser-card.is-foldable').forEach((el) => {
            once('productTeaserCard', () => initFoldableCard(el), [el]);
        });
    },
};
